import { ISnListQueryParameters } from '@lib/api';

export interface ISnApplianceSelectFieldOptions {
  params?: ISnListQueryParameters;
  exclude?: string | string[];
}
